import React from 'react'
import styles from './Page.module.css'
import Me from './Components/Me'
import References from './References'

var Home = () =>
    <div className={styles.page}>
        <div>
            <Me />
        </div>
        <References />

    </div>
export default Home